import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';

@Injectable()
export class DiscoverActivateGuard implements CanActivate {

    constructor(
        private currentUserState: CurrentUserStateService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserState.getAccount().pipe(
            // Waits til info is fetched from backend
            filter(x => x !== null),
            map(account => {
                if (account.permissions.find(x => x === userPermissionsEnum.advancedTargeting)) {
                    return true;
                } else {
                    return false;
                }
            })
        );
    }

}
